import { BookOpen, Home, Image, Palette, Settings, Sparkles, Users } from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

const links = [
  ["Home", "/app", Home], ["Magazines", "/app/publications", BookOpen], ["Media", "/app/media", Image],
  ["Contributors", "/app/contributors", Users], ["Brand", "/app/brand", Palette], ["Settings", "/app/settings", Settings]
] as const;

export function AppShell() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  return <div className="min-h-screen lg:grid lg:grid-cols-[252px_1fr]">
    <aside className="hidden border-r border-line bg-white p-5 lg:flex lg:flex-col">
      <div className="mb-9 flex items-center gap-3 px-2">
        <span className="grid size-10 place-items-center rounded-2xl bg-brand text-white"><Sparkles size={20} /></span>
        <div><div className="font-bold">SchoolMag AI</div><div className="text-xs text-muted">Designed by AI</div></div>
      </div>
      <nav className="space-y-1">
        {links.map(([label, to, Icon]) => <NavLink key={label} to={to} end={to === "/app"} className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-semibold ${isActive ? "bg-brand/10 text-brand" : "text-muted hover:bg-canvas hover:text-ink"}`}><Icon size={19} />{label}</NavLink>)}
      </nav>
      <div className="mt-auto rounded-2xl bg-ink p-4 text-white">
        <div className="mb-1 flex items-center gap-2 font-semibold"><Sparkles size={16} /> Ask SchoolMag</div>
        <p className="mb-3 text-xs text-white/65">Open a magazine page and describe the outcome you want.</p>
        <button className="text-xs font-semibold text-white/85 hover:text-white" onClick={() => void signOut().then(() => navigate("/auth"))}>Sign out</button>
      </div>
    </aside>
    <main className="min-w-0"><Outlet /></main>
  </div>;
}
